module.exports = __webpack_public_path__ + "static/img/1.dfcc6f2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/eng/1.png
// module id = 4nKZ
// module chunks = 0